import React, { Fragment } from "react";
import { Button, Menu } from "@theorgchartdev/storybook";
import {
  DoMergeCells,
  DoUnmergeCells,
  IsMergeDisabled
} from "@/appComponents/Blocks/Composites/LayoutHoverToolbar/Utils";
import { appstr } from "@coreapp/utils/appstr";

const BLEFormatOptions = [
  {
    value: "mergecells",
    options: [
      {
        value: "mergeall",
        clickHandler: DoMergeCells
      },
      {
        value: "unmergecells",
        clickHandler: DoUnmergeCells
      }
    ],
    disabled: IsMergeDisabled,
    divider: true
  },
  {
    value: "clearformat",
    disabled: true
  }
];

const BuildFormatOptions = () => {
  let options = [];
  for (let formatOpt of BLEFormatOptions) {
    let opt = {};
    opt.value = formatOpt.value;
    opt.label = appstr(formatOpt.value);
    opt.icon = formatOpt.icon;
    opt.divider = formatOpt.divider;
    opt.dataTestId = `mtb-layout-editor-format-menu-${formatOpt.value}`;
    if (formatOpt.options) {
      opt.options = formatOpt.options;
      opt.options.forEach(item => {
        item.label = appstr(item.value);
        item.dataTestId = `mtb-layout-editor-format-menu-${formatOpt.value}-${item.value}`;
      });
      opt.listProps = {
        "data-testid": `mtb-layout-editor-format-menu-${formatOpt.value}-popover`
      };
    }
    if (formatOpt.clickHandler) opt.clickHandler = formatOpt.clickHandler;
    opt.disabled =
      typeof formatOpt.disabled === "function"
        ? formatOpt.disabled(formatOpt.value)
        : formatOpt.disabled;
    options.push(opt);
  }
  return options;
};

export const BoxLayoutEditorFormatMenu = () => {
  return (
    <Fragment>
      <Menu
        dataTestId="mtb-layout-editor-format-menu"
        trigger={
          <Button modifier="ghost" size="medium" type="button">
            {appstr("Format")}
          </Button>
        }
        options={BuildFormatOptions()}
        listWidth={"medium"}
      />
    </Fragment>
  );
};
